import { render, staticRenderFns } from "./Coursedetails.vue?vue&type=template&id=afb54f32&scoped=true"
import script from "./Coursedetails.vue?vue&type=script&lang=js"
export * from "./Coursedetails.vue?vue&type=script&lang=js"
import style0 from "./Coursedetails.vue?vue&type=style&index=0&id=afb54f32&prod&scoped=true&lang=css"
import style1 from "./Coursedetails.vue?vue&type=style&index=1&id=afb54f32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb54f32",
  null
  
)

export default component.exports